// extracted by mini-css-extract-plugin
export default {"priceTableRow":"PriceTableRow_priceTableRow__OrwKQ"};